import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgPriority({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            fill="currentColor"
            className="priority_svg__MuiSvgIcon-root priority_svg__MuiSvgIcon-fontSizeMedium priority_svg__MuiBox-root priority_svg__css-1om0hkc"
            aria-hidden="true"
            viewBox="0 0 24 24"
            data-testid="PriorityHighIcon"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <circle cx={12} cy={19} r={2} />
            <path d="M10 3h4v12h-4z" />
        </svg>
    )
}
SvgPriority.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgPriority
